export abstract class RolesConstants {
  public static readonly VAT_BDOAdministrator: string = 'VAT_BDOAdministrator';
  public static readonly VAT_StandardUser: string = 'VAT_StandardUser';
  public static readonly VAT_SuperUser: string = 'VAT_SuperUser';
  public static readonly VAT_Manager: string = 'VAT_Manager';
  public static readonly VAT_Reader: string = 'VAT_Reader';
}
